exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clothing-catalog-modal__checkbox {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.clothing-catalog-modal__actions {\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -ms-flex-wrap: wrap;\r\n      flex-wrap: wrap;\r\n  gap: 0.75rem;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/work/internal-frontend/src/app/content-page/admin/clothing/clothing-catalog-modal.component.css
// module id = ../../../../../src/app/content-page/admin/clothing/clothing-catalog-modal.component.css
// module chunks = main